import { endOfDay } from "date-fns";
import {
  AISVesselDto,
  AtonUnit,
  BerthListDto,
  DamListDto,
  EquipmentDetailsDto,
  EventListDto,
  FairwayListDto,
  FerryListDto,
  LuodeDto,
  NauticalWarningItemDto,
  PortListDto,
  PortServiceItemDto,
  SeaSurveyListDto,
  TrackerDeviceDtoOfElisaDeviceDataDto,
  TrackerDeviceDtoOfTaivalDeviceDataDto,
} from "~/api/GeneratedApi";
import { GeojsonAttributes } from "~/pages/ProjectsPage/hooks/useProjectShapeFile";
import {
  AtoNMapItem,
  BerthMapItem,
  DamMapItem,
  EquipmentDetailsMapItem,
  EventMapItem,
  FairwayMapItem,
  FerryMapItem,
  LuodeMapItem,
  MapItem,
  NauticalWarningMapItem,
  PortMapItem,
  PortServiceMapItem,
  SeaSurveyMapItem,
  TaivalTrackerMapItem,
  VesselMapItem,
  YepzonTrackerMapItem,
} from "../types/mapItems";

export const eventDtoToEventData = (
  eventToConvert: EventListDto,
): EventMapItem => {
  return {
    ...eventToConvert,
    type: "event",
    mapId: `event${eventToConvert.id}`,
    expired:
      eventToConvert.endTimestamp &&
      endOfDay(eventToConvert.endTimestamp).valueOf() < new Date().valueOf(),
  };
};

export const portDtoToPortData = (portToConvert: PortListDto): PortMapItem => {
  return {
    ...portToConvert,
    type: "port",
    mapId: `port${portToConvert.id}`,
  };
};

export const fairwayDtoToFairwayData = (
  fairwayToConvert: FairwayListDto,
): FairwayMapItem => {
  return {
    ...fairwayToConvert,
    type: "fairway",
    mapId: `fairway${fairwayToConvert.id}`,
  };
};

export const aisVesselToMapItem = (
  vesselToConvert: AISVesselDto,
): VesselMapItem => {
  return {
    ...vesselToConvert,
    type: "vessel",
    mapId: `vessel${vesselToConvert.mmsi}`,
    name: vesselToConvert.name ?? "-",
    id: vesselToConvert.mmsi,
  };
};

export const seaSurveyToMapItem = (s: SeaSurveyListDto): SeaSurveyMapItem => {
  return {
    id: s.id,
    mapId: `measurement${s.id}`,
    name: s.name,
    type: "measurement",
    description: s.description,
    files: s.files,
    multiPoly: s.multiPoly,
    mapAreas: s.mapAreas,
    additionalHeightOffsetMm: s.additionalHeightOffsetMm,
    comparisonLevelOffsetMm: s.comparisonLevelOffsetMm,
  };
};

export const damToMapItem = (d: DamListDto): DamMapItem => {
  return {
    ...d,
    mapId: `dam${d.id}`,
    type: "dam",
  };
};

export const ferryToMapItem = (f: FerryListDto): FerryMapItem => {
  return {
    ...f,
    mapId: `ferry${f.id}`,
    type: "ferry",
  };
};

export const berthToMapItem = (f: BerthListDto): BerthMapItem => {
  return {
    ...f,
    mapId: `berth${f.id}`,
    type: "berth",
    name: f.name ?? `berth${f.id}`,
  };
};

export const atonToMapItem = (a: AtonUnit): AtoNMapItem => {
  return {
    ...a,
    mapId: `aton${a.atonNumber}`,
    type: "aton",
    name: a.name ?? `aton${a.atonNumber}`,
    atonType: a.type,
  };
};

export const nauticalWarningToMapItem = (
  n: NauticalWarningItemDto,
): NauticalWarningMapItem => {
  return {
    ...n,
    mapId: `nautical-warning${n.id}`,
    type: "nautical-warning",
    name: `nautical-warning${n.id}`,
  };
};

export const portServiceToMapItem = (
  f: PortServiceItemDto,
): PortServiceMapItem => {
  return {
    ...f,
    mapId: `port-service${f.id}`,
    type: "port-service",
    name: f.name ?? `port-service${f.id}`,
  };
};

export const luodeToMapItem = (d: LuodeDto): LuodeMapItem => {
  return {
    ...d,
    mapId: `condition${d.id}`,
    type: "condition",
    name: d.name ?? `condition${d.id}`,
  };
};

export const yepzonTrackerToMapItem = (
  y: TrackerDeviceDtoOfElisaDeviceDataDto,
): YepzonTrackerMapItem => {
  return {
    ...y,
    mapId: `yepzon-tracker${y.deviceId}`,
    type: "yepzon-tracker",
  };
};
export const taivalTrackerToMapItem = (
  y: TrackerDeviceDtoOfTaivalDeviceDataDto,
): TaivalTrackerMapItem => {
  return {
    ...y,
    mapId: `taival-tracker${y.deviceId}`,
    type: "taival-tracker",
  };
};

export const vehicleEquipmentToMapItem = (
  equipment: EquipmentDetailsDto,
): EquipmentDetailsMapItem => {
  return {
    ...equipment,
    name: equipment.name ?? `equipment${equipment.id}`,
    mapId: `equipment${equipment.id}`,
    type: "equipment",
  };
};

// export const ptopCarToMapItem = (c: PTOPCarListDto): PTOPCarMapItem => {
//   return {
//     ...c,
//     mapId: `ptop-car${c.id}`,
//     type: "ptop-car",
//     name: c.name ?? `ptop-car${c.id}`,
//   };
// };

// export const ptopTrailerToMapItem = (
//   c: PTOPTrailerListDto,
// ): PTOPTrailerMapItem => {
//   return {
//     ...c,
//     mapId: `ptop-trailer${c.id}`,
//     type: "ptop-trailer",
//     name: c.name ?? `ptop-trailer${c.id}`,
//   };
// };
// Geojson osaa lukea atribuutit suoraan, joten niitä ei tarvitse lisätä erikseen

export const projectShapePlanToMapItem = (
  f: GeojsonAttributes,
  popupName: string,
): MapItem => {
  return {
    type: "project-shape-plan",
    mapId: `project-shape-plan-${f.SubArea}`,
    name: `${popupName}-${String(f.SubArea)}`,
  };
};

// Geojson osaa lukea atribuutit suoraan, joten niitä ei tarvitse lisätä erikseen

export const projectShapeProgressToMapItem = (
  f: GeojsonAttributes,
  popupName: string,
): MapItem => {
  return {
    type: "project-shape-progress",

    mapId: `project-shape-progress-${f.Project}`,
    name: `${popupName}-${f.Vessel} ${f.SubArea} ${f.GeomArea}km2`,
  };
};
